export class CustomerProfileEditModel {
    public id: number;
    public displayName: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone: string;
    public livingCity: string;
    public payPalEmail: string;
    public mailingAddress: string;
    public zipCode: string;
    public highestEducationLevel: string;
    public highestEducationLevelId: string;
    public dateOfBirth: any;
    public profileImage: string;
    public profileImageUrl: string;
    public aboutMe: string;
    public education: string;
    public uniqueUrl: string;
    public facebookUrl: string;
    public instagramUrl: string;
    public twitterUrl: string;
    public behanceUrl: string;
    public snapchatUrl: string;
    public specializationTags: any;
    public referralCode: string;
}



// WEBPACK FOOTER //
// ./src/models/customer/customer.profile.edit.model.ts